<ion-content>
  <div class="constrained-content">
    <ion-grid>
      <ng-container *ngIf="isInitialized">
        <ion-row
          *ngIf="authService.integrations.slackEnabled && slackScopeRequired"
        >
          <ion-col size="12">
            <ion-card class="outline-card depthButton" (click)="connectSlack()">
              <ion-list class="no-padding">
                <ion-item class="transparent-bg">
                  <ion-icon name="warning-outline" class="icon-padded">
                  </ion-icon>
                  <ion-label text-wrap class="gradient-text">
                    <strong>
                      Please click here to reconnect your Slack workspace to
                      take advantage of all features.
                    </strong>
                  </ion-label>
                </ion-item>
              </ion-list>
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="showOnboarding" class="hidden-sm">
          <ion-col size="12">
            <ion-card
              class="outline-card depthButton"
              routerLink="/dashboard/onboarding"
              style="margin-top: 20px; padding: 0"
            >
              <div
                style="
                  font-weight: 600;
                  padding: 15px 25px;
                  display: flex;
                  align-items: center;
                "
              >
                <ion-icon
                  name="rocket"
                  style="font-size: 1.7rem; margin-right: 16px"
                ></ion-icon>
                <div class="gradient-text">
                  <p style="font-size: 1.1rem; margin: 5px 0">
                    {{ onboardingLabel }}
                  </p>
                  <p style="font-size: 0.85rem; margin: 0">
                    {{ onboardingNextStep }}
                  </p>
                </div>
              </div>
              <div class="onboarding-progress-bar">
                <div class="meter" [style.width.%]="onboardingPercentage"></div>
              </div>
            </ion-card>
          </ion-col>
        </ion-row>
      </ng-container>
      <ion-row>
        <ion-col size="12" size-md="6">
          <ion-button
            fill="clear"
            color="dark"
            class="btn-small"
            routerLink="/dashboard/inbox/me"
            routerDirection="root"
          >
            My Inbox
            <ion-icon
              name="chevron-forward-outline"
              class="icon-padded-left button-icon"
            ></ion-icon>
          </ion-button>
          <ion-card
            class="outline-card report-card depthButton"
            routerLink="/dashboard/inbox/me"
            routerDirection="root"
            style="height: unset"
          >
            <ion-row>
              <ion-col size="4" style="text-align: center">
                <span
                  class="report-stat"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <div class="blob red"></div>
                  <span class="stat-large">{{ myNeedsResponse }}</span>
                </span>
                <div class="report-title">Needs response</div>
              </ion-col>
              <ion-col size="4" style="text-align: center">
                <span
                  class="report-stat"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <div class="blob yellow"></div>
                  <span class="stat-large">{{ myInProgress }}</span>
                </span>
                <div class="report-title">In progress</div>
              </ion-col>
              <ion-col size="4" style="text-align: center">
                <span
                  class="report-stat"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <div class="blob gray"></div>
                  <span class="stat-large">{{ myOnHold }}</span>
                </span>
                <div class="report-title">On hold</div>
              </ion-col>
            </ion-row>
          </ion-card>
        </ion-col>
        <ion-col size="12" size-md="6">
          <ion-button
            fill="clear"
            color="dark"
            class="btn-small"
            routerLink="/dashboard/inbox/all"
            routerDirection="root"
          >
            All conversations
            <ion-icon
              name="chevron-forward-outline"
              class="icon-padded-left button-icon"
            ></ion-icon>
          </ion-button>
          <ion-card
            class="outline-card report-card depthButton"
            routerLink="/dashboard/inbox/all"
            routerDirection="root"
            style="height: unset"
          >
            <ion-row>
              <ion-col size="4" style="text-align: center">
                <span
                  class="report-stat"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <div class="blob red"></div>
                  <span class="stat-large">{{ allNeedsResponse }}</span>
                </span>
                <div class="report-title">Needs response</div>
              </ion-col>
              <ion-col size="4" style="text-align: center">
                <span
                  class="report-stat"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <div class="blob yellow"></div>
                  <span class="stat-large">{{ allInProgress }}</span>
                </span>
                <div class="report-title">In progress</div>
              </ion-col>
              <ion-col size="4" style="text-align: center">
                <span
                  class="report-stat"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <div class="blob gray"></div>
                  <span class="stat-large">{{ allOnHold }}</span>
                </span>
                <div class="report-title">On hold</div>
              </ion-col>
            </ion-row>
          </ion-card>
        </ion-col>
        <ion-col
          size="12"
          class="flex-space-between"
          *ngIf="authService.isTenantAdmin"
        >
          <ion-button
            fill="clear"
            color="dark"
            class="btn-small"
            (click)="showDateOptions()"
          >
            Last {{ dateRangeDays }} days
            <ion-icon
              name="chevron-down-outline"
              class="icon-padded-left button-icon"
            ></ion-icon>
          </ion-button>
          <ion-button
            fill="clear"
            color="dark"
            class="btn-small"
            (click)="showMedianOptions()"
          >
            <ion-icon name="settings-outline" class="button-icon"></ion-icon>
            <ion-icon
              name="chevron-down-outline"
              class="icon-padded-left button-icon"
            ></ion-icon>
          </ion-button>
        </ion-col>
        <ion-col size="6" size-md="4">
          <ion-card
            class="outline-card report-card"
            (click)="viewAnalytics('response')"
            [ngClass]="{ depthButton: authService.isTenantAdmin }"
          >
            <span class="report-stat">
              <span class="stat-large">{{ medianFirstResponse ?? "..." }}</span>
              <span class="stat-small">{{ medianFirstResponseLabel }}</span>
            </span>
            <div class="report-title">
              {{ isDisplayingMedian ? "Median" : "Average" }} response time
              <ion-icon
                *ngIf="authService.isTenantAdmin"
                name="information-circle-outline"
                ngxTippy
                [tippyProps]="{
                  arrow: false,
                  allowHTML: true,
                  placement: 'bottom',
                  content: 'Click to view more'
                }"
              >
              </ion-icon>
            </div>
          </ion-card>
        </ion-col>
        <ion-col size="6" size-md="4">
          <ion-card
            class="outline-card report-card"
            (click)="viewAnalytics('resolution')"
            [ngClass]="{ depthButton: authService.isTenantAdmin }"
          >
            <span class="report-stat">
              <span class="stat-large">{{ medianResolution ?? "..." }}</span>
              <span class="stat-small">{{ medianResolutionLabel }}</span>
            </span>
            <div class="report-title">
              {{ isDisplayingMedian ? "Median" : "Average" }} resolution time
              <ion-icon
                *ngIf="authService.isTenantAdmin"
                name="information-circle-outline"
                ngxTippy
                [tippyProps]="{
                  arrow: false,
                  allowHTML: true,
                  placement: 'bottom',
                  content: 'Click to view more'
                }"
              >
              </ion-icon>
            </div>
          </ion-card>
        </ion-col>
        <ion-col size="6" size-md="4">
          <ion-card
            class="outline-card report-card"
            (click)="viewAnalytics('conversations')"
            [ngClass]="{ depthButton: authService.isTenantAdmin }"
          >
            <span class="report-stat"
              ><span class="stat-large">{{
                avgTicketsPerDay ?? "..."
              }}</span></span
            >
            <div class="report-title">
              Avg new conversations per day
              <ion-icon
                *ngIf="authService.isTenantAdmin"
                name="information-circle-outline"
                ngxTippy
                [tippyProps]="{
                  arrow: false,
                  allowHTML: true,
                  placement: 'bottom',
                  content: 'Click to view more'
                }"
              >
              </ion-icon>
            </div>
          </ion-card>
        </ion-col>
        <ion-col size="6" size-md="4" class="shown-sm">
          <ion-card
            class="outline-card report-card depthButton"
            (click)="viewInbox()"
          >
            <span class="report-stat"
              ><span class="stat-large"
                ><ion-icon name="file-tray"></ion-icon></span
            ></span>
            <div class="report-title">View my inbox</div>
          </ion-card>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="12" size-md="6">
          <ion-card
            class="outline-card report-card"
            (click)="viewAnalytics('conversations')"
            [ngClass]="{ depthButton: authService.isTenantAdmin }"
          >
            <div class="report-title">
              Conversations started
              <ion-icon
                *ngIf="authService.isTenantAdmin"
                name="information-circle-outline"
                ngxTippy
                [tippyProps]="{
                  arrow: false,
                  allowHTML: true,
                  placement: 'bottom',
                  content: 'Click to view more'
                }"
              >
              </ion-icon>
            </div>
            <div *ngIf="isInitialized && conversationsChartLabels?.length">
              <canvas
                baseChart
                [datasets]="conversationsChartData"
                [labels]="conversationsChartLabels"
                [options]="conversationsChartOptions"
                type="line"
              >
              </canvas>
            </div>
            <div
              *ngIf="!isInitialized"
              style="
                min-height: 340px;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <ion-spinner name="crescent"></ion-spinner>
            </div>
            <div
              class="empty-top-chart"
              *ngIf="isInitialized && !conversationsChartLabels?.length"
            >
              <ion-icon name="stats-chart-outline" class="empty-top-chart-icon">
              </ion-icon>
              <div class="empty-top-chart-text">No conversations yet</div>
            </div>
          </ion-card>
        </ion-col>
        <ion-col size="12" size-md="6">
          <ion-card
            class="outline-card report-card"
            (click)="viewAnalytics('customers')"
            [ngClass]="{ depthButton: authService.isTenantAdmin }"
          >
            <div class="report-title">
              Conversations by channel
              <ion-icon
                *ngIf="authService.isTenantAdmin"
                name="information-circle-outline"
                ngxTippy
                [tippyProps]="{
                  arrow: false,
                  allowHTML: true,
                  placement: 'bottom',
                  content: 'Click to view more'
                }"
              >
              </ion-icon>
            </div>
            <div *ngIf="isInitialized && conversationsChartLabels?.length">
              <canvas
                baseChart
                [datasets]="customersPieData"
                [labels]="customersPieLabels"
                [options]="customersPieOptions"
                type="doughnut"
              >
              </canvas>
            </div>
            <div
              *ngIf="!isInitialized"
              style="
                min-height: 340px;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <ion-spinner name="crescent"></ion-spinner>
            </div>
            <div
              class="empty-top-chart"
              *ngIf="isInitialized && !conversationsChartLabels?.length"
            >
              <ion-icon name="pie-chart-outline" class="empty-top-chart-icon">
              </ion-icon>
              <div class="empty-top-chart-text">No conversations yet</div>
            </div>
          </ion-card>
        </ion-col>

        <ion-col size="12" size-md="6">
          <ion-card
            class="outline-card report-card"
            (click)="viewAnalytics('tags')"
            [ngClass]="{ depthButton: authService.isTenantAdmin }"
          >
            <div class="report-title">
              Conversations by tag
              <ion-icon
                *ngIf="authService.isTenantAdmin"
                name="information-circle-outline"
                ngxTippy
                [tippyProps]="{
                  arrow: false,
                  allowHTML: true,
                  placement: 'bottom',
                  content: 'Click to view more'
                }"
              >
              </ion-icon>
            </div>
            <div *ngIf="isInitialized && tagsPieLabels?.length">
              <canvas
                baseChart
                [datasets]="tagsPieData"
                [labels]="tagsPieLabels"
                [options]="tagsPieOptions"
                type="bar"
              >
              </canvas>
            </div>
            <div
              *ngIf="!isInitialized"
              style="
                min-height: 340px;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <ion-spinner name="crescent"></ion-spinner>
            </div>
            <div
              class="empty-top-chart"
              *ngIf="isInitialized && !tagsPieLabels.length"
            >
              <ion-icon name="bar-chart-outline" class="empty-top-chart-icon">
              </ion-icon>
              <div class="empty-top-chart-text">No tags applied</div>
            </div>
          </ion-card>
          <ion-card
            style="
              font-weight: 600;
              padding: 15px 25px;
              display: flex;
              align-items: center;
            "
            *ngIf="isInitialized && !tagsPieLabels.length"
            routerLink="/dashboard/tags"
            class="depthButton"
          >
            <div class="gradient-text">
              <span style="font-size: 1.1rem; margin: 5px 0">
                <ion-icon
                  name="bulb-outline"
                  style="font-size: 1.7rem; margin-right: 4px"
                ></ion-icon>
                Tip: Use tags to categorize conversations
              </span>
            </div>
          </ion-card>
        </ion-col>

        <ion-col size="12" size-md="6">
          <ion-card
            class="outline-card report-card"
            (click)="viewAnalytics('ticketTypes')"
            [ngClass]="{ depthButton: authService.isTenantAdmin }"
          >
            <div class="report-title">
              Conversations by ticket type
              <ion-icon
                *ngIf="authService.isTenantAdmin"
                name="information-circle-outline"
                ngxTippy
                [tippyProps]="{
                  arrow: false,
                  allowHTML: true,
                  placement: 'bottom',
                  content: 'Click to view more'
                }"
              >
              </ion-icon>
            </div>
            <div *ngIf="isInitialized && ticketTypesPieLabels?.length">
              <canvas
                baseChart
                [datasets]="ticketTypesPieData"
                [labels]="ticketTypesPieLabels"
                [options]="ticketTypesPieOptions"
                type="bar"
              >
              </canvas>
            </div>
            <div
              *ngIf="!isInitialized"
              style="
                min-height: 340px;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <ion-spinner name="crescent"></ion-spinner>
            </div>
            <div
              class="empty-top-chart"
              *ngIf="isInitialized && !ticketTypesPieLabels.length"
            >
              <ion-icon name="bar-chart-outline" class="empty-top-chart-icon">
              </ion-icon>
              <div class="empty-top-chart-text">No ticket types assigned</div>
            </div>
          </ion-card>
          <ion-card
            style="
              font-weight: 600;
              padding: 15px 25px;
              display: flex;
              align-items: center;
            "
            *ngIf="isInitialized && !ticketTypesPieLabels.length"
            routerLink="/dashboard/ticket-types"
            class="depthButton"
          >
            <div class="gradient-text">
              <span style="font-size: 1.1rem; margin: 5px 0">
                <ion-icon
                  name="bulb-outline"
                  style="font-size: 1.7rem; margin-right: 4px"
                ></ion-icon>
                Tip: Use ticket types to categorize conversations
              </span>
            </div>
          </ion-card>
        </ion-col>

        <ion-col size="12" size-md="6">
          <ion-card
            class="outline-card report-card"
            (click)="viewAnalytics('volume')"
            [ngClass]="{ depthButton: authService.isTenantAdmin }"
          >
            <div class="report-title">
              Messages received by day of week
              <ion-icon
                name="information-circle-outline"
                ngxTippy
                [tippyProps]="{
                  arrow: false,
                  allowHTML: true,
                  placement: 'bottom',
                  content: 'Showing last 30 days<br/>Click to view more'
                }"
              >
              </ion-icon>
            </div>
            <div *ngIf="isInitialized && dayOfWeekLabels?.length">
              <canvas
                baseChart
                [datasets]="messagesByDowDatasets"
                [labels]="dayOfWeekLabels"
                [options]="messagesByDowOptions"
                type="bar"
              ></canvas>
            </div>
            <div
              *ngIf="!isInitialized"
              style="
                min-height: 340px;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <ion-spinner name="crescent"></ion-spinner>
            </div>
            <div
              class="empty-top-chart"
              *ngIf="isInitialized && !dayOfWeekLabels.length"
            >
              <ion-icon name="bar-chart-outline" class="empty-top-chart-icon">
              </ion-icon>
              <div class="empty-top-chart-text">No data yet</div>
            </div>
          </ion-card>
        </ion-col>

        <ion-col size="12" size-md="6">
          <ion-card
            class="outline-card report-card"
            (click)="viewAnalytics('assignee')"
            [ngClass]="{ depthButton: authService.isTenantAdmin }"
          >
            <div class="report-title">
              Conversations by assignee
              <ion-icon
                name="information-circle-outline"
                ngxTippy
                [tippyProps]="{
                  arrow: false,
                  allowHTML: true,
                  placement: 'bottom',
                  content: 'Showing last 30 days<br/>Click to view more'
                }"
              >
              </ion-icon>
            </div>
            <div *ngIf="isInitialized && assigneePieLabels?.length">
              <canvas
                baseChart
                [datasets]="assigneePieData"
                [labels]="assigneePieLabels"
                [options]="assigneePieOptions"
                type="doughnut"
              >
              </canvas>
            </div>
            <div
              *ngIf="!isInitialized"
              style="
                min-height: 340px;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <ion-spinner name="crescent"></ion-spinner>
            </div>
            <div
              class="empty-top-chart"
              *ngIf="isInitialized && !assigneePieLabels.length"
            >
              <ion-icon name="bar-chart-outline" class="empty-top-chart-icon">
              </ion-icon>
              <div class="empty-top-chart-text">No conversations yet</div>
            </div>
          </ion-card>
        </ion-col>

        <!-- <ion-col size="12" size-md="6">
          <ion-card>
            <span class="report-stat">
              <span class="stat-large"><ion-icon name="mail"></ion-icon> 0</span>
            </span>
            <div class="report-title">Email inboxes</div>
          </ion-card>
          <ion-card
            style="font-weight: 600; padding: 15px 25px; display: flex; align-items: center"
            *ngIf="isInitialized && !tagsPieLabels.length"
            class="depthButton"
          >
            <ion-icon name="bulb-outline" style="font-size: 1.7rem; margin-right: 16px"></ion-icon>
            <div class="gradient-text">
              <p style="font-size: 1.1rem; margin: 5px 0">Tip: Connect your support email address to create tickets</p>
            </div>
          </ion-card>

          <ion-card style="margin-top: 20px">
            <span class="report-stat">
              <span class="stat-large"><ion-icon name="chatbubble"></ion-icon> 0</span>
            </span>
            <div class="report-title">In-app chat widgets</div>
          </ion-card>
          <ion-card
            style="font-weight: 600; padding: 15px 25px; display: flex; align-items: center"
            *ngIf="isInitialized && !tagsPieLabels.length"
            class="depthButton"
          >
            <ion-icon name="bulb-outline" style="font-size: 1.7rem; margin-right: 16px"></ion-icon>
            <div class="gradient-text">
              <p style="font-size: 1.1rem; margin: 5px 0">Tip: Embed in-app chat in your website</p>
            </div>
          </ion-card>

          <ion-card style="margin-top: 20px">
            <span class="report-stat">
              <span class="stat-large"><ion-icon name="send"></ion-icon> 0</span>
            </span>
            <div class="report-title">Slack Broadcasts</div>
          </ion-card>
          <ion-card
            style="font-weight: 600; padding: 15px 25px; display: flex; align-items: center"
            *ngIf="isInitialized && !tagsPieLabels.length"
            class="depthButton"
          >
            <ion-icon name="bulb-outline" style="font-size: 1.7rem; margin-right: 16px"></ion-icon>
            <div class="gradient-text">
              <p style="font-size: 1.1rem; margin: 5px 0">Tip: Send broadcasts across multiple Slack channels</p>
            </div>
          </ion-card>
        </ion-col> -->
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
